module.exports = __webpack_public_path__ + "img/laser-right.a4b7c33.jpg";